import { BrandLogo } from '@repo/ui/components/brand-logo';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@repo/ui/components/card';
import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { consumePendingRedirect } from '../lib/post-auth-redirect';
import { useT } from '../locales/context';

export function VerifyEmail() {
  const t = useT();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const navigate = useNavigate();

  useEffect(() => {
    if (error) return;
    // workspace-members cycle (THI-110 Task 5) — best-effort honoring of the same pending
    // `/invite/:token` redirect SignIn.tsx consumes (lib/post-auth-redirect.ts). Best-effort
    // only: this survives when sign-up and verification happen in the SAME tab, but a real
    // verification-link click almost always opens a fresh tab, where `sessionStorage` (by
    // design, see that helper's doc comment) carries nothing — that visitor lands on '/' same
    // as before this change, not on an error.
    const timer = setTimeout(() => navigate(consumePendingRedirect() ?? '/'), 1000);
    return () => clearTimeout(timer);
  }, [error, navigate]);

  return (
    <div className="grid min-h-screen place-items-center p-6">
      <div className="flex w-full max-w-sm flex-col items-center gap-6">
        <BrandLogo size={40} />
        <Card className="w-full max-w-sm">
          <CardHeader>
            <CardTitle>{error ? t.auth.verifyFailedTitle : t.auth.verifiedTitle}</CardTitle>
            <CardDescription>
              {error ? t.auth.verifyFailedBody : t.auth.verifiedBody}
            </CardDescription>
          </CardHeader>
          {error && (
            <CardContent>
              <Link to="/sign-in" className="text-sm underline">
                {t.auth.backToSignIn}
              </Link>
            </CardContent>
          )}
        </Card>
      </div>
    </div>
  );
}
